import { render, staticRenderFns } from "./examGuidance.vue?vue&type=template&id=18690e74&scoped=true&"
import script from "./examGuidance.vue?vue&type=script&lang=js&"
export * from "./examGuidance.vue?vue&type=script&lang=js&"
import style0 from "./examGuidance.vue?vue&type=style&index=0&id=18690e74&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18690e74",
  null
  
)

export default component.exports